import { ChangePartner } from './ChangePartner';

export class ChangePartnerText extends ChangePartner {
  type: string = 'Partner.ChangeText';
}
